import type { Notification } from "@contracts";

/** Spec 20261028-132500: the sentence of each kind. The notice carries no name or text, so the sentence is the screen's. */
export const KIND_TITLE: Record<Notification["kind"], string> = {
  acrescimo_em_revisao: "Acréscimo esperando revisão",
  acrescimo_aprovado: "Acréscimo aprovado",
  acrescimo_recusado: "Acréscimo recusado",
  material_pendente: "Material pendente",
  retirada_recebida: "Retirada recebida",
  ocorrencia_aberta: "Nova ocorrência",
  ocorrencia_respondida: "Ocorrência respondida",
};

export const BELL_TEXT = {
  title: "Notificações",
  close: "Fechar",
  empty: "Nada novo por aqui.",
  readAll: "Marcar todas como lidas",
  loadError: "Não foi possível carregar as notificações. Tente novamente.",
  retry: "Tentar novamente",
  unread: "não lidas",
};

/** A short age: "agora", "há 5 min", "há 3 h", "há 2 d". */
export function ageOf(iso: string, now = Date.now()): string {
  const minutes = Math.floor(Math.max(0, now - new Date(iso).getTime()) / 60_000);
  if (minutes < 1) return "agora";
  if (minutes < 60) return `há ${minutes} min`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `há ${hours} h`;
  return `há ${Math.floor(hours / 24)} d`;
}

/**
 * AC-9: where a notice leads. An acréscimo opens its page; an occurrence opens its detail on the occurrences page;
 * a retirada opens the Gestão, where retiradas are listed (it has no page of its own yet).
 */
export function pathOf(notice: Pick<Notification, "subjectType" | "subjectId">): string {
  const id = encodeURIComponent(notice.subjectId);
  switch (notice.subjectType) {
    case "acrescimo":
      return `/acrescimo/${id}`;
    case "ocorrencia":
      return `/occurrence?id=${id}`;
    default:
      return "/acrescimo";
  }
}
